import useSite from '~/client/hooks/useSite';
import NextLink, { LinkProps } from '~/client/shared/NextLink';
import SigninButtonView from './SiginButtonView';

type Props = {
  href?: LinkProps['href'];
  onClick?: () => void;
  hasShadow?: boolean;
};

const SigninButton: FC<Props> = ({ href = '/login', hasShadow, onClick }) => {
  const { isBridgeSite } = useSite();

  if (!isBridgeSite && onClick) {
    return <SigninButtonView isLink onClick={onClick} hasShadow={hasShadow} />;
  }
  return (
    <NextLink href={href}>
      <SigninButtonView hasShadow={hasShadow} />
    </NextLink>
  );
};

export default SigninButton;
